import {Component, ComponentRef, EventEmitter, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';

declare let window: any;
// declare let amplify: any;

export enum TooltipColor {
    BLACK = <any> "BLACK"
    , WHITE = <any> "WHITE"
}

export enum TooltipEventAction {
    TOGGLE = <any> "TOGGLE"
    , HIDE = <any> "HIDE"
}

export interface TooltipEvent {
    action: TooltipEventAction;
    currentTarget?: any;
    tooltipModel?: any;
}

export enum TooltipAction {
    CLICK = <any> "CLICK"
    , HOVER = <any> "HOVER"
    , EVENT = <any> "EVENT"
}

export enum TooltipPosition {
    CENTER_TOP = <any> "CENTER_TOP"
    , CENTER_BOTTOM = <any> "CENTER_BOTTOM"
    , LEFT_BOTTOM = <any> "LEFT_BOTTOM"
    , LEFT_TOP = <any> "LEFT_TOP"
    , RIGHT_TOP = <any> "RIGHT_TOP"
    , RIGHT_BOTTOM = <any> "RIGHT_BOTTOM"
}

export enum TooltipSize {
    NORMAL = <any> "NORMAL"
    , SMALL = <any> "SMALL"
}

export interface TooltipConfig {
    enableTooltip?: boolean;
    content?: string;
    tooltipClass?: string;
    component?: any;
    eventEmitter?: EventEmitter<TooltipEvent>;
    tooltipColor?: TooltipColor;
    tooltipAction?: TooltipAction;
    tooltipModel?: any;
}

// TODO mejoras angular ver si se pueden unier el TooltipConfig y el TooltipData en un solo objeto
export interface TooltipData {
    tooltipId: string;
    tooltipConfig: TooltipConfig;
    touchEnabled?: boolean;
    tooltipPosition: TooltipPosition;
    tooltipTitle?: string;
    tooltipShowClose: boolean;
    tooltipSize?: TooltipSize;
    padding?: string;
    leftOffset?:number;
    topOffset?:number;

}

@Component({
    selector: 'tooltip',
    template: `
        <span id="{{tooltipData.tooltipId}}" class="eva-3-tooltip {{tooltipTypeClass}} {{tooltipData.tooltipConfig.tooltipClass}} -no-hover"
              [ngClass]="{'-show-tooltip': visible, '-lg': tooltipData.tooltipTitle
                          , '-white': tooltipData.tooltipConfig.tooltipColor.toString() == 'WHITE'
                          , '-with-close': !tooltipData.tooltipTitle && tooltipData.tooltipShowClose}"
              [ngStyle]="{'position': 'absolute', 'width': width + 'px', 'height': height + 'px', 'top': top + 'px', 'left': left + 'px'}">
            <span class="tooltip-container eva-3-shadow" [ngStyle]="getPadding()" >
                <i class="tooltip-marker" [ngClass]="{'-bottom-marker': !positionIsTop, '-top-marker': positionIsTop}"></i>
                <span class="tooltip-content" *ngIf="initialized">
                    <span class="tooltip-header" *ngIf="tooltipData.tooltipTitle || tooltipData.tooltipShowClose">
                        <div *ngIf="tooltipData.tooltipTitle" class="tooltip-title -eva-3-tc-gray-0 -eva-3-bold">{{tooltipData.tooltipTitle}}</div>
                        <i (click)="hide()" class="eva-3-icon-close tooltip-close" [style.display]="tooltipData.tooltipShowClose ? 'block' : 'none'"></i>
                    </span>
                    <span class="tooltip-body tooltip-text">
                        <span *ngIf="tooltipData.tooltipConfig.content != null">
                            {{tooltipData.tooltipConfig.content}}
                        </span>
                
                        <span *ngIf="tooltipData.tooltipConfig.component != null">
                            <dynamic-component [component]="tooltipData.tooltipConfig.component" [model]="tooltipData.tooltipConfig.tooltipModel"></dynamic-component>
                        </span>
                        
                        <span *ngIf="tooltipData.tooltipConfig.content == null && tooltipData.tooltipConfig.component == null">
                            <p>{{tooltipData.tooltipConfig.tooltipModel}}</p>
                        </span>
                    </span>
                </span>
            </span>
        </span>
    `,
    styleUrls: ['./tooltip.component.scss']
    , encapsulation: ViewEncapsulation.None
})
export class TooltipComponent implements OnInit, OnDestroy {
    public static instances: any = {};
    tooltipData: TooltipData;
    targetElement: any;
    componentRef: ComponentRef<any>;
    visible: boolean;

    tooltipTypeClass: string;
    initialized: boolean; // esta propiedad es para evitar que parpedee cuando se inserta en el dom
    width: number;
    height: number;
    top: number;
    left: number;
    observer: any;
    private _eventSubscription: any;
    positionIsTop: boolean;

    constructor() {
        this.visible = false;
        this.initialized = false;
        this.width = 1;
        this.height = 0;
    }

    init(tooltipData: TooltipData, targetElement: any, componentRef: ComponentRef<any>) {
        this.tooltipData = tooltipData;
        this.targetElement = targetElement;
        this.componentRef = componentRef;

        if (this.tooltipData.tooltipId != null) {
            if (TooltipComponent.instances[this.tooltipData.tooltipId] != null) {
                TooltipComponent.instances[this.tooltipData.tooltipId].hide();
            }
            TooltipComponent.instances[this.tooltipData.tooltipId] = this;

        } else {
            this.tooltipData.tooltipId = "default-tooltip";
        }

        if (this.tooltipData.tooltipConfig.enableTooltip == null) {
            this.tooltipData.tooltipConfig.enableTooltip = true;
        }

        if (this.tooltipData.tooltipConfig.eventEmitter != null) {
            this._eventSubscription = this.tooltipData.tooltipConfig.eventEmitter.subscribe((event: TooltipEvent) => this.tooltipEventHandler(event));
        }
    }

    ngOnInit() {
        this.initialized = true;

        switch (this.tooltipData.tooltipPosition) {
            case TooltipPosition.CENTER_TOP:
                this.tooltipTypeClass = "-center -top";
                break;

            case TooltipPosition.CENTER_BOTTOM:
                this.tooltipTypeClass = "-center -bottom";
                break;

            case TooltipPosition.LEFT_BOTTOM:
                this.tooltipTypeClass = "-left -bottom";
                break;

            case TooltipPosition.LEFT_TOP:
                this.tooltipTypeClass = "-left -top";
                break;

            case TooltipPosition.RIGHT_TOP:
                this.tooltipTypeClass = "-right -top";
                break;

            case TooltipPosition.RIGHT_BOTTOM:
                this.tooltipTypeClass = "-right -bottom";
                break;

            default:
                break;
        }

        if (this.tooltipData.tooltipSize == TooltipSize.SMALL) {
            this.tooltipTypeClass += ' -sm';
        }
        this.positionIsTop = this.tooltipData.tooltipPosition.toString().indexOf('TOP')>=0;
    }

    show() {
        if (this.componentRef.location.nativeElement.parentNode == null) {
            document.querySelector("body").appendChild(this.componentRef.location.nativeElement); // muevo el elemento al body
        }

        this.calculatePosition();

        setTimeout(() => {
            this.visible = true;
            // amplify.publish("popupShow", {id: this.tooltipData.tooltipId});
        }, 10);
    }

    calculatePosition(){
        let clientRect = this.targetElement.getBoundingClientRect();

        let position = {
            'CENTER_TOP' : { toAdd: 5, rect: clientRect.top  },
            'RIGHT_TOP':{ toAdd: 5, rect: clientRect.top  },
            'LEFT_TOP':{ toAdd: 5, rect: clientRect.top  },
            'CENTER_BOTTOM' : { toAdd: -5, rect: clientRect.bottom  },
            'RIGHT_BOTTOM':{ toAdd: -5, rect: clientRect.bottom  },
            'LEFT_BOTTOM':{ toAdd: -5, rect: clientRect.bottom  }

        };
        const pos = position[this.tooltipData.tooltipPosition];
        this.width = this.targetElement.offsetWidth;
        this.left = clientRect.left + window.scrollX - (this.tooltipData.leftOffset?this.tooltipData.leftOffset:0) ;
        this.top = pos.rect+ window.scrollY + pos.toAdd - (this.tooltipData.topOffset?this.tooltipData.topOffset:0);
    }

    hide() {
        this.visible = false;

        setTimeout(() => {
            if (this.tooltipData.tooltipConfig.tooltipAction == TooltipAction.HOVER) {
                this.componentRef.destroy();
                if (this.observer){
                    this.observer.disconnect();
                }
            } else if (this.componentRef.location.nativeElement.parentNode != null) {
                document.querySelector("body").removeChild(this.componentRef.location.nativeElement); // elimino el elemento del body
            }
        }, 200);
    }

    toggleVisibility(): boolean {
        let visibleResult = !this.visible; // no se devuelve el this.visible porque hay timeouts para el cambio

        if (this.visible) {
            this.hide();

        } else {
            this.show();
        }

        return visibleResult;
    }

    tooltipEventHandler(event: TooltipEvent) {
        if (this.tooltipData.tooltipConfig.enableTooltip && (event.currentTarget == null || this.targetElement == event.currentTarget)) {

            if (event.tooltipModel != null) {
                this.tooltipData.tooltipConfig.tooltipModel = event.tooltipModel;
            }

            if (event.action == TooltipEventAction.TOGGLE) {
                this.toggleVisibility();

            } else if (event.action == TooltipEventAction.HIDE) {
                this.hide();
            }
        }
    }

    ngOnDestroy() {
        if (this._eventSubscription != null) {
            this._eventSubscription.unsubscribe();
        }
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    getPadding() {
        if( this.tooltipData.padding && this.tooltipData.padding !== '' ){
            return {padding: this.tooltipData.padding};
        }
            return {};

    }

}
